import { C1Checkbox, C1CheckboxProps } from './C1Checkbox'
import { C1CheckboxPrettyDisplay } from './C1CheckboxPrettyDisplay'

export { C1Checkbox, C1CheckboxPrettyDisplay }
export type { C1CheckboxProps }
